import {documentReady, slideToggle, slideUp, index} from '../Utility/utils';

documentReady(event => {

  // Accordion Toggle
  const accordions = document.querySelectorAll('.accordion__trigger');
  accordions.forEach(item => {
    item.addEventListener('click', toggleAccordion);
    item.addEventListener('keypress', toggleAccordion);
  });

  function toggleAccordion(e){
    e.preventDefault();

    if(e.type === 'click' || e.key === 'Enter' ){

      const el = e.target;
      const target = el.nextElementSibling;
      const accordion_item = el.closest('.accordion__item');

      if(!target){
        return;
      }

      const scrollPos = window.pageYOffset | document.body.scrollTop;
      let elTopPos = accordion_item.getBoundingClientRect().top + scrollPos;

      // Close any open items within accordion list that isn't this element
      const accordionList = target.closest('.accordion__list');

      if(accordionList){
        const activeListItem = accordionList.querySelector('.accordion__item.active');
        if(activeListItem && activeListItem !== accordion_item){
          const activeTrigger = activeListItem.querySelector('.accordion__trigger');
          const activeContent = activeListItem.querySelector('.accordion__content');

          activeListItem.classList.remove('active');
          activeTrigger.classList.remove('active');
          activeContent.classList.remove('active');

          // If the previously active item is above the new accordion item, alter the elTopPos variable
          const activeIndex   = index(activeListItem);
          const clickedIndex  = index(accordion_item);
          if(activeIndex < clickedIndex){
            const activeHeight = activeContent.offsetHeight;
            elTopPos = elTopPos - activeHeight;
          }

          activeContent.setAttribute('aria-hidden', 'true');
          slideUp(activeContent);
        }
      }

      // Toggle active class
      accordion_item.classList.toggle('active');
      el.classList.toggle('active');
      target.classList.toggle('active');

      // Toggle Aria-Hidden attribute
      const aria_hidden = target.classList.contains('active') ? 'false' : 'true';
      target.setAttribute('aria-hidden', aria_hidden);

      // Toggle Content Height
      slideToggle(target);

      // Slide window to active item position
      const adminBarEl = document.getElementById("wpadminbar");
      const adminBarHeight = adminBarEl ? adminBarEl.offsetHeight : 0;
      elTopPos = elTopPos - adminBarHeight - 20;
      scroll({
        top: elTopPos,
        behavior: "smooth",
      });
    }
  }
});
